import { ethers } from "ethers";

export const buyAtFixedPrice = async (
  metaspaceNFTMarketplaceContract,
  address,
  token
) => {
  const tx = await metaspaceNFTMarketplaceContract.buyAtFixedPrice(
    address,
    token
  );
  const rec = tx.wait(1);
  return rec;
};
export const createSignature = async (
  signatureCreationContract,
  address,
  contract,
  token,
  tradeToken,
  price,
  signer,
  provider
)=>{
   try{
    let newPrice=ethers.parseUnits(`${price}`, 18);
 let currency = "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6";
  if(tradeToken.toLowerCase() === "matic"){
    currency="0x0000000000000000000000000000000000001010"
  }else if(tradeToken.toLowerCase() === "mld"){
    currency="0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6"
  }else if(tradeToken.toLowerCase() === "usdt"){
    currency="0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
  }
  const nonce= await provider.getTransactionCount(address, "latest");
  console.log("purchasedata--------------------------------------------->",address,contract,token,tradeToken,newPrice,currency,nonce);
  const tx = await signatureCreationContract.getMessageHashForNFTTransfer(
    address,
    contract,
    token,
    currency,
    newPrice,
    nonce+1,
  )
  if(tx?.signedMessageHash){
    const signature = await signer.signMessage(ethers.getBytes(tx?.messageHash));
    const recoveredAddress = ethers.verifyMessage(
      ethers.getBytes(tx?.messageHash),
      signature
    );

    console.log("purchasedata--------------------------------------------->", recoveredAddress);
    // console.log("purchasedata--------------------------------------------->",signature, tx?.signedMessageHash);
    return {signature:signature,signedMessageHash:tx?.signedMessageHash};
  }
  else{
    return null;
  }
   }catch(err){
    console.log("purchasedata--------------------------------------------->Error in createSignature", err);
   }
}
export const maticBuyAtFixedPrice = async (
  metaspaceNFTMarketplaceContract,
  address,
  token,
  maticvalue
) => {
  console.log("maticvalue", maticvalue);
  // console.log("contract", address, token);
  const tx = await metaspaceNFTMarketplaceContract.buyAtFixedPrice(
    address,
    token,
    {
      value: maticvalue,
    }
  );
  const rec = tx.wait(1);
  return rec;
};
